import React, { useState } from 'react';

export const DataContext = React.createContext({});

export const DataProvider = ({ children }) => {
  const [dataPromise, setDataPromise] = useState(null);
  const [data, setData] = useState(null);

  return (
    <DataContext.Provider value={{
      dataPromise,
      setDataPromise,
      data,
      setData,
    }}
    >
      {children}
    </DataContext.Provider>
  );
};
